import React from "react";
import { SxProps } from "@mui/material";
import { SubmissionReviewStatus } from "../../types";
import { Status, StatusChip } from "../StatusChip";

export interface Props {
  status: SubmissionReviewStatus;
  sx?: SxProps;
}

const statuses: Record<
  SubmissionReviewStatus,
  { status: Status; label: string }
> = {
  [SubmissionReviewStatus.Draft]: { status: "warning", label: "Draft" },
  [SubmissionReviewStatus.SubmissionsOpen]: {
    status: "success",
    label: "Submissions Open",
  },
  [SubmissionReviewStatus.SubmissionsClosed]: {
    status: "warning",
    label: "Submissions Closed",
  },
  [SubmissionReviewStatus.ReviewsOpen]: {
    status: "success",
    label: "Reviews Open",
  },
  [SubmissionReviewStatus.ReviewsClosed]: {
    status: "error",
    label: "Reviews Closed",
  },
  [SubmissionReviewStatus.ResultsReleased]: {
    status: "success",
    label: "Results Released",
  },
};

export const SubmissionReviewState = ({ status, sx }: Props) => {
  return <StatusChip {...statuses[status]} sx={sx} />;
};
